<template>
  <base-filter-expander
    :title="$t('search.dealer-location')"
    :with-validation="false"
  >
    <div class="dealer dealer--mobile">
      <a
        :aria-label="$t('details.view-on-google-maps')"
        :href="generateLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <base-location :name="name" :address="address" :town="town" />
      </a>
      <base-phone class="dealer__phone" :tel="phone" />
    </div>
    <div class="dealer dealer--desktop">
      <div class="dealer__left">
        <h1 class="dealer__name">{{ name }}</h1>
        <a
          :href="generateLink"
          :aria-label="$t('details.view-on-google-maps')"
          target="_blank"
          rel="noopener noreferrer"
        >
          <base-button>{{ $t("details.view-on-google-maps") }}</base-button>
        </a>
      </div>
      <div class="dealer__right">
        <div
          v-for="(value, description) in dealerDetails"
          :key="description"
          class="detail"
        >
          <div class="detail__description">
            {{ description }}
          </div>
          <div class="detail__value">
            {{ value }}
          </div>
        </div>
      </div>
    </div>
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import BaseLocation from "@/components/ui/BaseLocation/BaseLocation.vue";
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
import BasePhone from "@/components/ui/BasePhone/BasePhone.vue";

export default {
  name: "DetailsDealerLocation",
  components: {
    BaseFilterExpander,
    BaseLocation,
    BaseButton,
    BasePhone
  },
  props: {
    name: {
      type: String,
      required: true
    },
    address: {
      type: String,
      default: "N/A"
    },
    email: {
      type: String,
      default: "N/A"
    },
    phone: {
      type: String,
      default: "N/A"
    },
    town: {
      type: String,
      default: "N/A"
    },
    latitude: {
      type: String,
      default: ""
    },
    longitude: {
      type: String,
      default: ""
    }
  },
  computed: {
    generateLink() {
      return `https://www.google.com/maps/search/?api=1&query=${
        this.latitude
      },${this.longitude}`;
    },
    dealerDetails() {
      return {
        address: this.address || "N/A",
        email: this.email || "N/A",
        phone: this.phone || "N/A",
        town: this.town || "N/A"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.dealer {
  &--desktop {
    display: none;
  }

  &__phone {
    display: block;
    padding: 15px 0 10px;
  }
}

@media screen and (min-width: $media-l) {
  .dealer {
    &--mobile {
      display: none;
    }

    &--desktop {
      display: flex;
    }

    &__name {
      color: $color-blue-300;
      margin: 0;
      padding-bottom: 20px;
      border-bottom: 1px solid $color-grey-100;
    }

    &__left,
    &__right {
      flex-basis: 50%;
      padding: 0 20px;
    }

    &__left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  .detail {
    padding: 5px 0;
    box-sizing: border-box;

    &__description {
      color: $color-grey-300;
      text-transform: uppercase;
      font-size: $font-size-m;
    }
  }
}
</style>
